<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          {{ lastServerError || 'Error occurred' }}
        </div>

        <app-mat-simple-select [formControl]="categoryControl"
                               label="Category" name="category"
                               [selectItems]="customFieldsService.customFieldCategories"
                               [submitted]="submitted"></app-mat-simple-select>

        <app-mat-text-input [formControl]="fieldTitleControl"
                            label="Field Title" name="fieldTitle"
                            [submitted]="submitted"></app-mat-text-input>

        <app-mat-text-input [formControl]="fieldKeyControl"
                            label="Field Key" name="fieldKey"
                            [submitted]="submitted"
                            hintLabel="Field Key Ex.: address.state, address_city, status.name"
                            [customErrors]="{pattern: 'Invalid field key. A field key must start with a letter or _ or ., and can contain only alphanumeric characters or _ or ..'}"
        ></app-mat-text-input>

        <app-mat-simple-select [formControl]="fieldTypeControl"
                               label="Field Type" name="fieldType"
                               [selectItems]="customFieldsService.customFieldTypes"
                               [submitted]="submitted"></app-mat-simple-select>

        <app-mat-simple-select [formControl]="fieldFormatControl"
                               *ngIf="fieldTypeControl.getRawValue() == 'text' || fieldTypeControl.getRawValue() == 'list'"
                               label="Field Format" name="fieldFormat"
                               [selectItems]="customFieldsService.customFieldFormats"
                               [submitted]="submitted"></app-mat-simple-select>

        <app-mat-number-input [formControl]="fieldOrderControl"
                              label="Field Order" name="fieldOrder"
                              [submitted]="submitted"></app-mat-number-input>

        <app-mat-checkbox-input [formControl]="requiredControl"
                                label="Is Required" name="required"
                                [submitted]="submitted"></app-mat-checkbox-input>

        <app-mat-checkbox-input [formControl]="includeInSearchControl"
                                label="Include In Search" name="includeInSearch"
                                [submitted]="submitted"></app-mat-checkbox-input>

        <app-mat-checkbox-input [formControl]="includeInAnySearchControl"
                                label="Include In Search Any Text" name="includeInAnySearch"
                                [submitted]="submitted"></app-mat-checkbox-input>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button type="button" mat-raised-button color="primary" matTooltip="Save changes"
          (click)="onSubmit()"
          [promiseBtn]="buttonSubmitPromise"
          *ngIf="hasEditAccess">
    Save
  </button>
  <button type="button" mat-raised-button color="warn" class="only-icon" matTooltip="Remove Custom Field"
          (click)="onDeleteClick()"
          *ngIf="hasDeleteAccess && editModel.id && editModel.id !== 'new'">
    <mat-icon>delete</mat-icon>
  </button>
</div>
